module.exports = __webpack_public_path__ + "media/mfg/truck-7075a4c3.jpg";